import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const AdminUser = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16 27.6667C22.4433 27.6667 27.6667 22.4433 27.6667 16C27.6667 9.55673 22.4433 4.33333 16 4.33333C9.55673 4.33333 4.33333 9.55673 4.33333 16C4.33333 22.4433 9.55673 27.6667 16 27.6667ZM16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 23.732 8.26801 30 16 30Z"
		/>
		<path d="M16.3705 10.9799H15.6495L11.4435 23H9L13.9671 9H18.0128L23 23H20.5565L16.3705 10.9799ZM11.7239 17.62H19.8956V19.58H11.7239V17.62Z" />
	</svg>
);

export default AdminUser;
